import React, { useEffect, useState } from "react";
import { hamiltonZipcodeConfig } from "../config/hamilton-zipcode-config";
import { showToast } from "../helper-methods";
import useFormValidation from "../hooks/useFormValidation";
import { addProviderConfig } from "../config/form-validation/addProviderConfig";
import { zipCdes } from "../config/zipcodeConfig";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  CustomInput,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Tooltip,
} from "reactstrap";
import { countryCodes } from "../config/country-codes";
import ReactSelect from "react-select";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import { createProvider, updateProvider } from "../http/http-calls";
import Swal from "sweetalert2";
import GoogleMapInput from "../helper-methods/googleMapInput";

const CreateResourceComponent = ({
  services,
  toggle,
  isEdit,
  editDetails,
  fetchAllProvider,
}) => {
  const history = useHistory();
  const [flag, setFlag] = useState(false);
  const [countyList, setCountyList] = useState([]);
  const [prevValue, setPrevValue] = useState({});

  const demographicOptions = ["adults", "youth", "older adults"];

  const initialValues = {
    contactName: "",
    providerName: "",
    providerEmail: "",
    countryCode: "+1",
    providerPhone: "",
    providerAddress: "",
    providerWebsiteUrl: "",
    pincode: [],
    service: [],
    isNonProfit: false,
    demographic: [],
    isChargeable: "yes",
    description: "",
    city: "",
    zipCode: "",
    state: "",
  };

  const {
    formErrors,
    formValues,
    handleInputBlur,
    handleInputChange,
    handleSubmit,
    setFormValues,
    setFormErrors,
    handleChipBlur,
    handlePincodeChange,
    handleServiceChange,
    checkedAllPincode,
  } = useFormValidation(
    initialValues,
    _onSubmit,
    addProviderConfig,
    countyList,
    demographicOptions
  );

  const _naviGateHandler = () => {
    if (isEdit) {
      toggle();
      setFormErrors({});
    } else {
      history.push("/home");
    }
  };

  // serviceList
  const serviceList = services?.map((each) => {
    return {
      id: each?._id,
      label: each?.serviceName,
      value: each?.serviceName,
    };
  });

  const [tooltipOpen, setTooltipOpen] = useState([false, false, false]);
  const _toggle = (i) => {
    const newArray = tooltipOpen.map((each, index) => {
      return index === i ? !each : false;
    });
    setTooltipOpen(newArray);
  };

  async function _onSubmit(values) {
    let countyDetails = values?.pincode?.map((data) =>
      zipCdes?.find((countyData) => countyData?.postalCode === Number(data))
    );

    setFlag(true);
    let ProviderName = values?.contactName?.trim()?.split(" ");
    let name = { first: ProviderName[0], last: ProviderName[1] };
    let newphone = values.countryCode.concat("-", values.providerPhone);
    let finalPayload = {
      ...values,
      contactName: name,
      providerPhone: newphone,
      county: countyDetails,
      isChargeable: values.isChargeable === "yes" ? true : false,
      address: {
        addressLne: values.providerAddress || "",
        city: values.city || "",
        zipcode: values.zipCode || "",
        state: values.state || "",
      },
    };
    delete finalPayload.countryCode;
    delete finalPayload.providerAddress;
    delete finalPayload.city;
    delete finalPayload.state;
    delete finalPayload.zipCode;

    if (isEdit) {
      try {
        const res = await updateProvider(editDetails?._id, finalPayload);
        console.log("createProvider", res);
        fetchAllProvider();
        _naviGateHandler();

        showToast("Provider Updated Successfully!", "success");
      } catch (error) {
        console.log("error", error);
        showToast(
          error.reason && error.reason.length
            ? error.reason
            : "Server error. Try again after sometime.",
          "error"
        );
      }
    } else {
      try {
        const res = await createProvider(finalPayload);
        console.log("createProvider", res);
        _naviGateHandler();

        showToast(
          res.message && res.message.length
            ? res.message
            : "Provider Created Successfully!",
          "success"
        );
        Swal.fire({
          title: "Application Submitted",
          text: `Your application has been submitted successfully! You will receive a notification once the admin reviews and approves or rejects your application.`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#25215e",
          confirmButtonText: "Ok",
        });
      } catch (error) {
        console.log("error", error);
        showToast(
          error.reason && error.reason.length
            ? error.reason
            : "Server error. Try again after sometime.",
          "error"
        );
      }
    }

    setFlag(false);
  }

  const _addProviderHandler = (e) => {
    handleSubmit(e, formValues);
  };

  const selectedServices = serviceList.filter((service) =>
    formValues?.service.includes(service.id)
  );

  const _onChangeAddress = (value) => {
    const { description, city, pinCode, state } = value; // Destructure state

    setFormValues((prev) => ({
      ...prev,
      providerAddress: description || "",
      city: city || "",
      zipCode: pinCode || "",
      state: state || "", // Update state
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      providerAddress: "",
      city: "",
      zipCode: "",
      state: "", // Clear state error
    }));
  };

  useEffect(() => {
    const updatedCountyList = hamiltonZipcodeConfig.map((each) => ({
      label: each?.postalCode,
      value: each?.postalCode,
    }));

    setCountyList(updatedCountyList);
  }, []);

  useEffect(() => {
    if (isEdit !== undefined && editDetails !== null) {
      const phoneNumberParts = editDetails.providerPhone.split("-");

      const formData = {
        contactName: editDetails.contactName?.full || "",
        providerName: editDetails.providerName || "",
        providerEmail: editDetails.providerEmail || "",
        countryCode: phoneNumberParts[0] || "",
        providerPhone: phoneNumberParts[1] || "",
        providerWebsiteUrl: editDetails.providerWebsiteUrl || "",
        pincode: editDetails._county?.map((data) => data.postalCode) || [],
        service: editDetails?._service?.map((data) => data?._id) || [],
        isNonProfit: !!editDetails.isNonProfit,
        isChargeable: editDetails.isChargeable ? "yes" : "no",
        description: editDetails?.description,
        demographic: editDetails?.demographic,
        providerAddress: editDetails?.address?.addressLne || "",
        city: editDetails?.address?.city || "",
        zipCode: editDetails?.address?.zipcode || "",
        state: editDetails?.address?.state || "",
      };

      setFormValues(formData);
      setPrevValue(formData);
    }
  }, [isEdit, editDetails, setFormValues]);

  return (
    <div>
      <Row className="justify-content-center" noGutters>
        <Col
          xl="6"
          lg="8"
          md="10"
          style={isEdit ? { maxWidth: "100%", flex: "1" } : undefined}
        >
          <Card className="p-0 p-sm-3">
            <CardHeader>
              <CardTitle className="fs-22 text-theme fw-bold text-center">
                {isEdit ? "Update" : "Join"} Resource Database
              </CardTitle>
            </CardHeader>
            <CardBody>
              <Form>
                {/* ==== Primary Contact Name ==== */}
                <FormGroup>
                  <Label>Primary Contact Name</Label>
                  <Input
                    type="text"
                    placeholder="Enter"
                    autoComplete="off"
                    name="contactName"
                    value={formValues?.contactName}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                  />
                  {formErrors?.contactName ? (
                    <div className="form-error">{formErrors?.contactName}</div>
                  ) : null}
                </FormGroup>

                {/* ==== Company Name ==== */}
                <FormGroup>
                  <Label>Company Name</Label>
                  <Input
                    type="text"
                    placeholder="Enter"
                    autoComplete="off"
                    name="providerName"
                    value={formValues?.providerName}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                  />
                  {formErrors?.providerName ? (
                    <div className="form-error">{formErrors?.providerName}</div>
                  ) : null}
                </FormGroup>

                {/* ==== Email ==== */}
                <FormGroup>
                  <Label>Email</Label>

                  <Input
                    type="text"
                    placeholder="Enter"
                    autoComplete="off"
                    name="providerEmail"
                    disabled={isEdit}
                    value={formValues?.providerEmail}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                  />
                  {formErrors?.providerEmail ? (
                    <div className="form-error">
                      {formErrors?.providerEmail}
                    </div>
                  ) : null}
                </FormGroup>

                {/* ==== Phone ==== */}
                <FormGroup>
                  <Label>Phone</Label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <Input
                        type="select"
                        placeholder="Enter"
                        autoComplete="off"
                        name="countryCode"
                        disabled
                        value={formValues?.countryCode}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                      >
                        {countryCodes.map((each) => (
                          <option key={each.code} value={each.dial_code}>
                            {each.code} ({each.dial_code})
                          </option>
                        ))}
                      </Input>
                    </InputGroupAddon>
                    <Input
                      type="text"
                      placeholder="Enter"
                      autoComplete="off"
                      name="providerPhone"
                      value={formValues?.providerPhone}
                      onChange={handleInputChange}
                      onBlur={handleInputBlur}
                    />
                  </InputGroup>

                  {formErrors?.providerPhone ? (
                    <div className="form-error">
                      {formErrors?.providerPhone}
                    </div>
                  ) : null}
                </FormGroup>

                {/* ==== Addtess ==== */}
                <FormGroup>
                  <Label>Address</Label>
                  <GoogleMapInput
                    onChange={(obj) => _onChangeAddress(obj)}
                    value={formValues.providerAddress}
                  />
                  {formErrors?.providerAddress ? (
                    <div className="form-error">
                      {formErrors?.providerAddress}
                    </div>
                  ) : null}
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col md={4}>
                      <Label>City</Label>

                      <Input
                        type="text"
                        placeholder="Enter"
                        autoComplete="off"
                        name="city"
                        value={formValues?.city}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                      />
                      {formErrors?.city ? (
                        <div className="form-error">{formErrors?.city}</div>
                      ) : null}
                    </Col>
                    <Col md={4}>
                      <Label>State</Label>
                      <Input
                        type="text"
                        placeholder="Enter"
                        autoComplete="off"
                        name="state"
                        value={formValues?.state}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                      />
                      {formErrors?.state ? (
                        <div className="form-error">{formErrors?.state}</div>
                      ) : null}
                    </Col>

                    <Col md={4}>
                      <Label>ZIP Code</Label>

                      <Input
                        type="text"
                        placeholder="Enter"
                        autoComplete="off"
                        name="zipCode"
                        value={formValues?.zipCode}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                      />
                      {formErrors?.zipCode ? (
                        <div className="form-error">{formErrors?.zipCode}</div>
                      ) : null}
                    </Col>
                  </Row>
                </FormGroup>

                {/* ==== Website URL ==== */}
                <FormGroup>
                  <Label>Website URL or Social Media Link</Label>
                  <Input
                    type="text"
                    placeholder="Enter"
                    autoComplete="off"
                    name="providerWebsiteUrl"
                    value={formValues?.providerWebsiteUrl}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                  />
                  {formErrors?.providerWebsiteUrl ? (
                    <div className="form-error">
                      {formErrors?.providerWebsiteUrl}
                    </div>
                  ) : null}
                </FormGroup>

                <FormGroup>
                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <Label className="d-flex align-items-center mr-2">
                      Select the County or Counties you serve
                      <i
                        id="county_strong_veteran"
                        className="fa fa-info-circle ml-1"
                      />
                      <Tooltip
                        autohide={false}
                        placement="right"
                        isOpen={tooltipOpen[0]}
                        target="county_strong_veteran"
                        toggle={() => _toggle(0)}
                      >
                        Resources ZIP Code!
                      </Tooltip>
                    </Label>
                    <CustomInput
                      className="mb-2"
                      type="checkbox"
                      id="isAllPincode"
                      label="All ZIP Code"
                      checked={
                        formValues?.isAllPincode
                          ? formValues?.isAllPincode
                          : formValues?.pincode?.length === 18
                      }
                      onChange={(event) =>
                        checkedAllPincode(event.target.checked)
                      }
                    />
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-12">
                      <Select
                        isSearchable={true}
                        closeMenuOnSelect={false}
                        value={formValues?.pincode?.map((each, index) => ({
                          id: index,
                          label: each,
                          value: each,
                        }))}
                        isMulti={true}
                        options={countyList}
                        name="pincode"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        onChange={handlePincodeChange}
                        onBlur={() => handleChipBlur("pincode")}
                        placeholder="Select all that apply"
                      />
                      {formErrors.pincode ? (
                        <div className="form-error">{formErrors.pincode}</div>
                      ) : null}
                    </div>
                  </div>
                </FormGroup>
                <FormGroup>
                  <Label className="d-flex align-items-center">
                    Select the Service or Services You Provide
                    <i
                      className="fa fa-info-circle ml-1"
                      id="service_strong_veteran_page"
                    />
                    <Tooltip
                      autohide={false}
                      placement="right"
                      isOpen={tooltipOpen[1]}
                      target="service_strong_veteran_page"
                      toggle={() => _toggle(1)}
                    >
                      Provide Services!
                    </Tooltip>
                  </Label>
                  <div className="react-select">
                    <ReactSelect
                      isSearchable={true}
                      closeMenuOnSelect={false}
                      name="service"
                      isMulti
                      value={selectedServices}
                      options={serviceList}
                      onChange={handleServiceChange}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      onBlur={() => handleChipBlur("service")}
                      placeholder="Select all that apply"
                    />
                  </div>
                  {formErrors.service ? (
                    <div className="form-error">{formErrors.service}</div>
                  ) : null}
                </FormGroup>
                <FormGroup>
                  <Label>Demographic</Label>
                  <div className="radio-group">
                    <FormGroup check>
                      <Input
                        type="checkbox"
                        value="all"
                        checked={
                          formValues?.demographic?.length ===
                          demographicOptions.length
                        }
                        onChange={handleInputChange}
                        name="demographic"
                        id="demographic1"
                      />
                      <Label check for="demographic1">
                        All
                      </Label>
                    </FormGroup>

                    <FormGroup check>
                      <Input
                        type="checkbox"
                        value="adults"
                        checked={formValues?.demographic?.includes("adults")}
                        onChange={handleInputChange}
                        name="demographic"
                        id="demographic2"
                      />
                      <Label check for="demographic2">
                        Adults
                      </Label>
                    </FormGroup>
                    <FormGroup check>
                      <Input
                        type="checkbox"
                        value="youth"
                        checked={formValues?.demographic?.includes("youth")}
                        onChange={handleInputChange}
                        name="demographic"
                        id="demographic3"
                      />
                      <Label check for="demographic3">
                        Youth
                      </Label>
                    </FormGroup>
                    <FormGroup check>
                      <Input
                        type="checkbox"
                        value="older adults"
                        checked={formValues?.demographic?.includes(
                          "older adults"
                        )}
                        onChange={handleInputChange}
                        name="demographic"
                        id="demographic4"
                      />
                      <Label check for="demographic4">
                        Older Adults
                      </Label>
                    </FormGroup>
                  </div>
                  {formErrors?.demographic ? (
                    <div className="form-error">{formErrors?.demographic}</div>
                  ) : null}
                </FormGroup>

                <FormGroup className="mt-4">
                  <Label className="d-flex align-items-center mr-2">
                    Description
                    <i id="description" className="fa fa-info-circle ml-1" />
                    <Tooltip
                      autohide={false}
                      placement="right"
                      isOpen={tooltipOpen[2]}
                      target="description"
                      toggle={() => _toggle(2)}
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "keep-all",
                        maxWidth: "300px",
                      }}
                    >
                      Use this space (300 words) to share your story. Describe
                      who you are, what you offer, and the difference it makes
                      for the people or organizations you serve. Think of it
                      like a short intro that shows both your purpose and your
                      results.
                    </Tooltip>
                  </Label>
                  <div className="row align-items-center">
                    <div className="col-md-12">
                      <Input
                        type="textarea"
                        placeholder="We help [who you serve] by providing [what you offer], so they can [outcome or result]."
                        autoComplete="off"
                        name="description"
                        rows="4"
                        value={formValues?.description}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                      />

                      {formErrors.description ? (
                        <div className="form-error">
                          {formErrors.description}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </FormGroup>

                <FormGroup className="mt-3">
                  <CustomInput
                    className="custom-color"
                    type="checkbox"
                    id="exampleCustomCheckbox"
                    label="Are You a Non Profit?"
                    checked={formValues?.isNonProfit}
                    name="isNonProfit"
                    onChange={handleInputChange}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Do you charge for your services?</Label>
                  <div className="radio-group">
                    <FormGroup check>
                      <Input
                        type="radio"
                        value="yes"
                        checked={formValues?.isChargeable === "yes"}
                        onChange={handleInputChange}
                        name="isChargeable"
                        id="isChargeable1"
                      />
                      <Label check for="isChargeable1">
                        Yes
                      </Label>
                    </FormGroup>
                    <FormGroup check>
                      <Input
                        type="radio"
                        value="no"
                        checked={formValues?.isChargeable === "no"}
                        onChange={handleInputChange}
                        name="isChargeable"
                        id="isChargeable2"
                      />
                      <Label check for="isChargeable2">
                        No
                      </Label>
                    </FormGroup>
                  </div>
                  {formErrors?.isChargeable ? (
                    <div className="form-error">{formErrors?.isChargeable}</div>
                  ) : null}
                </FormGroup>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div className="submitWrapper">
        <Button color="primary" outline onClick={() => _naviGateHandler()}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={_addProviderHandler}
          disabled={
            (isEdit &&
              JSON.stringify(formValues) === JSON.stringify(prevValue)) ||
            flag === true
          }
        >
          {isEdit ? "Update" : "Add"}
        </Button>
      </div>
    </div>
  );
};

export default CreateResourceComponent;
